import {openPopupWindow} from "../../../../../../../emitters/popup";
import trim from "mn-utils/trim";
import isEmail from "mn-utils/isEmail";
import Popup from "../../../../../../dumb/Popup/B";
import WrapperWithLoading from "../../../../../../dumb/WrapperWithLoading/B";
import TextField from "../../../../../../dumb/TextField/A";
import ButtonAccept from "../../../../../../dumb/Button/Accept";
import {apiTerminalNotificationEmailEdit} from "../../../../../../../api/merchant/terminals";
import map from "mn-utils/map";
import ButtonM from "../../../../../../dumb/Button/Decline";
import React from "react";

export default (data, update) => openPopupWindow((setPopupState, popup) => {
  const {close} = popup;

  const id = data.id;
  const notificationsEmail = data.notifications_email;

  popup.state = {
    notificationsEmail: notificationsEmail || '',
  };

  return (stateOfPopup) => {
    const {
      notificationsEmail,
      clicked
    } = stateOfPopup;
    const _notificationsEmail = trim(notificationsEmail);
    // const notificationsEmailRequired = !_notificationsEmail;
    const notificationsEmailInvalid = _notificationsEmail && !isEmail(_notificationsEmail);

    const error = notificationsEmailInvalid;

    return (
      <Popup
        caption={(
          <div className="layoutRow fhaS fvaC w">
            <div>Edit Notification Email</div>
            <div className="mh30 fw3 rlv st-2">|</div>
            <div className="f12 fx1 wmin0 tov ov wsNW">{id}</div>
          </div>
        )}
      >
        <WrapperWithLoading
          loading={stateOfPopup.loading}
        >
          <TextField
            className="mt25 wmax430"
            label="Notification Email"
            value={notificationsEmail}
            onChange={(e) => {
              setPopupState({
                notificationsEmail: e.target.value,
              });
            }}
            error={clicked && error}
          />
          <div className="mt50 cfx mh-28 (lt|ph28|pb20)>1">
            <div>
              <ButtonAccept
                disabled={clicked && error}
                onClick={() => {
                  setPopupState({
                    clicked: true,
                    loading: true,
                  })

                  if (error) {
                    setPopupState({
                      loading: false,
                    });

                    return;
                  }

                  apiTerminalNotificationEmailEdit({
                    mpos_id: id,
                    notifications_email: _notificationsEmail,
                  }).finally((error) => {
                    setPopupState({
                      loading: false,
                    });
                    if (error) {
                      return;
                    }
                    update();
                    // openPopupInfo(['Terminal has been changed']);
                    close();
                  });
                }}
              >Save</ButtonAccept>
            </div>
            <div>
              <ButtonM
                onClick={close}
              >Cancel</ButtonM>
            </div>
          </div>
        </WrapperWithLoading>
      </Popup>
    );
  };
});
